import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const DeliveryBillingIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M25.4296 10.25H20.25V23.25H30.25L30.25 18.75L25.8982 18.1053C24.4755 17.8945 23.3605 16.7738 23.1571 15.35L22.8315 13.0707C22.7885 12.7695 23.0222 12.5 23.3265 12.5H28L27.0937 11.1406C26.7228 10.5842 26.0983 10.25 25.4296 10.25Z"
          fill="#006DFF"
        />
        <path
          d="M1.75 7C1.75 5.20508 3.20507 3.75 5 3.75H17C18.7949 3.75 20.25 5.20507 20.25 7V23.25H1.75V7Z"
          fill="white"
        />
        <path
          d="M15.75 10C15.75 10.5523 15.3023 11 14.75 11C14.1977 11 13.75 10.5523 13.75 10C13.75 9.44772 14.1977 9 14.75 9C15.3023 9 15.75 9.44772 15.75 10Z"
          fill="#006DFF"
        />
        <path
          d="M13.2025 8.73294C12.5327 8.42297 11.7865 8.25 11 8.25C8.10051 8.25 5.75 10.6005 5.75 13.5C5.75 16.3995 8.10051 18.75 11 18.75C13.8995 18.75 16.25 16.3995 16.25 13.5C16.25 12.8417 16.1288 12.2117 15.9076 11.6311C15.5809 11.8634 15.1814 12 14.75 12C13.6454 12 12.75 11.1046 12.75 10C12.75 9.51914 12.9197 9.07791 13.2025 8.73294Z"
          fill="#006DFF"
        />
        <path
          d="M1.75 23.25H30.25V24.25C30.25 25.3546 29.3546 26.25 28.25 26.25H3.75C2.64543 26.25 1.75 25.3546 1.75 24.25V23.25Z"
          fill="#C0AAFE"
        />
        <path
          d="M10.25 25.25C10.25 26.9069 8.90685 28.25 7.25 28.25C5.59315 28.25 4.25 26.9069 4.25 25.25C4.25 23.5931 5.59315 22.25 7.25 22.25C8.90685 22.25 10.25 23.5931 10.25 25.25Z"
          fill="#E4E0FF"
        />
        <path
          d="M27.75 25.25C27.75 26.9069 26.4069 28.25 24.75 28.25C23.0931 28.25 21.75 26.9069 21.75 25.25C21.75 23.5931 23.0931 22.25 24.75 22.25C26.4069 22.25 27.75 23.5931 27.75 25.25Z"
          fill="#E4E0FF"
        />
        <path
          d="M22.5 17.625C22.8452 17.625 23.125 17.9048 23.125 18.25V19.25C23.125 19.5952 22.8452 19.875 22.5 19.875C22.1548 19.875 21.875 19.5952 21.875 19.25V18.25C21.875 17.9048 22.1548 17.625 22.5 17.625Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 3C2.79086 3 1 4.79086 1 7V24.25C1 25.7688 2.23122 27 3.75 27H3.93252C4.56127 28.1895 5.81098 29 7.25 29C8.68902 29 9.93873 28.1895 10.5675 27H21.4325C22.0613 28.1895 23.311 29 24.75 29C26.189 29 27.4387 28.1895 28.0675 27H28.25C29.7688 27 31 25.7688 31 24.25V18.7559L31 18.75V16.4806C31 15.9376 30.8393 15.4069 30.5382 14.9551L28.6241 12.084L28.6211 12.0795L27.7178 10.7246C27.2077 9.95953 26.3491 9.5 25.4296 9.5H21V7C21 4.79086 19.2091 3 17 3H5ZM29.5 22.5V19.3971L25.7883 18.8472C24.0373 18.5878 22.665 17.2084 22.4147 15.4561L22.0891 13.1768C21.9815 12.4237 22.5658 11.75 23.3265 11.75H26.5986L26.4697 11.5566C26.2379 11.2089 25.8476 11 25.4296 11H21V22.5H22.2005C22.8695 21.8794 23.7655 21.5 24.75 21.5C25.7345 21.5 26.6305 21.8794 27.2995 22.5H29.5ZM28.2866 24C28.4248 24.391 28.5 24.8117 28.5 25.25C28.5 25.326 28.4977 25.4015 28.4933 25.4763C29.0672 25.3631 29.5 24.8571 29.5 24.25V24H28.2866ZM21.2134 24H10.7866C10.9248 24.391 11 24.8117 11 25.25C11 25.334 10.9972 25.4174 10.9918 25.5H21.0082C21.0028 25.4174 21 25.334 21 25.25C21 24.8117 21.0752 24.391 21.2134 24ZM9.79953 22.5H19.5V7C19.5 5.61929 18.3807 4.5 17 4.5H5C3.61929 4.5 2.5 5.61929 2.5 7V22.5H4.70047C5.36953 21.8794 6.26546 21.5 7.25 21.5C8.23454 21.5 9.13046 21.8794 9.79953 22.5ZM3.71338 24H2.5V24.25C2.5 24.8571 2.93281 25.3631 3.50672 25.4763C3.50226 25.4015 3.5 25.326 3.5 25.25C3.5 24.8117 3.57519 24.391 3.71338 24ZM23.6148 13.25H27.5986L29.2901 15.7872C29.427 15.9925 29.5 16.2338 29.5 16.4806V17.8807L26.0081 17.3634C24.9138 17.2013 24.0561 16.3391 23.8996 15.2439L23.6148 13.25ZM5 25.25C5 24.0074 6.00736 23 7.25 23C8.49264 23 9.5 24.0074 9.5 25.25C9.5 26.4926 8.49264 27.5 7.25 27.5C6.00736 27.5 5 26.4926 5 25.25ZM22.5 25.25C22.5 24.0074 23.5074 23 24.75 23C25.9926 23 27 24.0074 27 25.25C27 26.4926 25.9926 27.5 24.75 27.5C23.5074 27.5 22.5 26.4926 22.5 25.25Z"
          fill="#0F3893"
        />
        <path
          d="M22.8315 13.0707C22.7885 12.7695 23.0222 12.5 23.3265 12.5H28L29.9141 15.3712C30.1331 15.6997 30.25 16.0857 30.25 16.4806V18.75L25.8982 18.1053C24.4755 17.8945 23.3605 16.7738 23.1571 15.35L22.8315 13.0707Z"
          fill="white"
          stroke="#0F3893"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
);
export default DeliveryBillingIcon;
